import { render, staticRenderFns } from "./AccessorialsGlobal.vue?vue&type=template&id=7b0fc77a&scoped=true&"
import script from "./AccessorialsGlobal.vue?vue&type=script&lang=js&"
export * from "./AccessorialsGlobal.vue?vue&type=script&lang=js&"
import style0 from "./AccessorialsGlobal.vue?vue&type=style&index=0&id=7b0fc77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0fc77a",
  null
  
)

export default component.exports